import React, { useLayoutEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import TransitionLink from 'gatsby-plugin-transition-link'
import VisibilitySensor from 'react-visibility-sensor'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import prevImage from "../images/Hero_09_Markets.jpg"
import nextImage from "../images/Hero_07_Planning.jpg"
import prevRings from "../images/RINGS_BLUE_YELLOW.svg"
import nextRings from "../images/RINGS_BLUE_YELLOW.svg"
import arrowLeft from "../images/yellow-arrow.svg"
import chevronDown from "../images/angle-down.svg"
import iconShield from "../images/shield.svg"
import iconForecasting from "../images/forecasting.svg"
import iconTransmission from "../images/transmission.svg"
import iconOperations from "../images/operations.svg"
import footerLogo from "../images/LOGO_PJM.svg"
import { Link } from "gatsby"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"
import circleCyan from "../images/CYAN.svg"
import circleMagenta from "../images/MAGENTA.svg"
import circleGreen from "../images/GREEN.svg"
import circleYellow from "../images/yellow.svg"
import innBubble1 from "../images/inn-bubble-1.svg"
import innBubble2 from "../images/inn-bubble-2.svg"
import innBubble3 from "../images/inn-bubble-3.svg"
import innBubble4 from "../images/inn-bubble-4.svg"
import innBubble5 from "../images/inn-bubble-5.svg"
import innArrow from "../images/inn-arrow.svg"
import innCloud from "../images/inn-cloud.svg"
import innPlay from "../images/inn-arrow.svg"
import imgAsim from "../images/quote_05_reliability_resilience.jpg"

import "../components/pages.scss"

gsap.registerPlugin(ScrollTrigger);

const ReliabilityPage = (props) => {
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();
    const bubble1 = useRef();
    const bubble2 = useRef();
    const bubble3 = useRef();
    const bubble4 = useRef();
    const bubble5 = useRef();
    const secondBubble1 = useRef();
    const secondBubble2 = useRef();
    const secondBubble3 = useRef();
    const secondBubble4 = useRef();

    useLayoutEffect(() => {
        // console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    function exitAnimation(exit, node, int) {
        gsap.to(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }

    function onChangeSecondBubble(isVisible) {
        let tl = gsap.timeline({paused: true})
        .fromTo(secondBubble1.current, {opacity: 0, x: -100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.5")
        .fromTo(secondBubble2.current, {opacity: 0, x: 0, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")
        .fromTo(secondBubble3.current, {opacity: 0, x: 100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")
        .fromTo(secondBubble4.current, {opacity: 0, x: 100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")

        if(isVisible) {
            tl.play(0);
        }
    }

    return (
        <Layout>
            <main className="page reliability">
                <title>Reliability & Resilience</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                 <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 5 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="reliability" className="text--yellow">Reliability & Resilience</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile">
                                        <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_05_Reliability_Resilience.jpg" alt="" />
                                        <img className="rings" src={ringsbm} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div className="title--super text--outline">TRANSFORMING</div>
                                        <h1>THE GRID</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                                exit={{
                                                    
                                                }}
                                                entry={{
                                                }}
                                            >
                                                Read Welcome
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img src={chevronDown} alt="" className="chevron-down"/>
                                </div>
                                <div 
                                    className="circle--pink top"
                                    ref={(element) => circles.current[0] = element}
                                    data-speed="-.3"
                                ></div>
                                <div
                                    className="circle--green top" 
                                    ref={(element) => circles.current[1] = element}
                                    data-speed=".3"
                                ></div>
                                <div
                                    className="circle--yellow top" 
                                    ref={(element) => circles.current[2] = element}
                                    data-speed=".1"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                   <div className="col-xs-12">
                        <p className="text text--intro">PJM worked to facilitate decarbonization policies reliably and cost-effectively. In 2021, PJM’s General Session focused on the intersection of reliability and decarbonization, drawing perspectives from NERC President and CEO James Robb. The industry’s “3-D transformation,” Robb said, “features decarbonization, distributed resources and digitization.” </p>
                        <p className="text text--intro">As state and federal policymakers respond to increasing consumer preferences for decarbonized generation resources, our generation interconnection queue has followed suit. More than 95% of the generation resources lining up in the PJM interconnection queue are solar, wind, storage or a hybrid combination of variable renewables. Beyond traditional industry practices, which shore up capacity to meet the needs of the grid, resource flexibility is also growing in importance. As more variable resources come onto the system, the role of balancing power systems becomes ever more critical.</p>
                   </div>
                </div>
                <div className="bg-blue p-t-40 p-b-40 sec-pad">
                   <div className="row row-wrapper content max--1024">
                       <div className="col-xs-12 text--center">
                           <p className="text text--yellow text--large quote-text">“This change is happening now. It’s not a theoretical, distant thing. I only expect these trends to accelerate over time.”</p>
                           <p className="text text--yellow text--uppercase text--large quote-name">Manu Asthana, President & CEO</p>
                       </div>
                   </div>
               </div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">Independent Insight: Reliability and Renewable Integration</h5>
                        <p className="text">To offer expert, independent insight into the forces at work in the electricity industry, PJM’s white paper, “<a href="https://pjm.com/-/media/library/reports-notices/special-reports/2021/20210311-reliability-in-pjm-today-and-tomorrow.ashx" className="text-link" target="_blank">Reliability in PJM: Today and Tomorrow</a>,” documented:</p>
                       <ul>
                           <li>What measures are required for PJM grid operators to maintain reliability every day</li>
                           <li>What PJM specifically does to ensure reliability</li>
                           <li>How PJM is preparing for the future while meeting the challenges of the changing grid</li>
                       </ul>
                        <p className="text">The white paper also outlined four building blocks of reliability:</p>
                    </div>
                </div>
              
                <div className="sec-pad">
                    <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeSecondBubble}>
                            <div className="row row-wrapper content icon-text-wrapper p-b-40">
                                <div className="col-xs-12 p-b-40">
                                    <div className="bubble-wrap row row-wrapper">
                                        <div ref={secondBubble1} className="col-xs-12 col-md-3">
                                            <div className="icon-wrap">
                                                <img src={circleCyan} alt="" className="circle-background"/>
                                                <img src={iconShield} alt="" className="icon"/>
                                            </div>   
                                            <h3 className="text--blue text--center text--uppercase">Adequate<br></br> Supply</h3>     
                                        </div>
                                        <div ref={secondBubble2} className="col-xs-12 col-md-3">
                                            <div className="icon-wrap">
                                                <img src={circleYellow} alt="" className="circle-background"/>
                                                <img src={iconForecasting} alt="" className="icon"/>
                                            </div>
                                            <h3 className="text--blue text--center text--uppercase">Accurate<br></br> Forecasting</h3>    
                                        </div>
                                        <div ref={secondBubble3} className="col-xs-12 col-md-3">
                                            <div className="icon-wrap">
                                                <img src={circleMagenta} alt="" className="circle-background"/>
                                                <img src={iconTransmission} alt="" className="icon"/>
                                            </div>
                                            <h3 className="text--blue text--center text--uppercase">Robust<br></br> Transmission</h3>    
                                        </div>
                                        <div ref={secondBubble4} className="col-xs-12 col-md-3">
                                            <div className="icon-wrap">
                                                <img src={circleGreen} alt="" className="circle-background"/>
                                                <img src={iconOperations} alt="" className="icon"/>
                                            </div>  
                                            <h3 className="text--blue text--center text--uppercase">Reliable<br></br> Operations</h3>      
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </VisibilitySensor>
                    </div>


                <div
                    className="circle--green page-1" 
                    ref={(element) => circles.current[3] = element}
                    data-speed=".1"
                ></div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h6 className="text--uppercase">Reliability: What It Takes</h6>
                        <p className="text">PJM remains focused on maintaining essential reliability services. To ensure continued reliability for our rapidly changing grid, PJM anticipates the following trends:</p>
                        <ul>
                            <li>Continuing market evolution</li>
                            <li>Increasing Installed Reserve Margins</li>
                            <li>Decreasing energy market prices as wind and solar produce electricity at or near zero cost</li>
                            <li>Requiring flexible generation with responsive ramping capability</li>
                            <li>Increasing interdependency between regions for backup power across seams</li>
                        </ul>
                        <p className="text">
                        Thoughtful, collaborative consideration of these forces is required now and in the future, as inverter-based, renewable resources emerge as key players within the generation resource mix. 
                        </p>
                   </div>
                </div>
                <div className="bg-blue p-t-40 p-b-40 sec-pad">
                   <div className="row row-wrapper content max--1024">
                       <div className="col-xs-12 text--center">
                           <p className="text text--yellow text--large quote-text">“Resilience is critical, and it takes deliberate effort.”</p>
                           <p className="text text--yellow text--uppercase text--large quote-name">Manu Asthana, President & CEO</p>
                       </div>
                   </div>
               </div>
               <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">How PJM Helps Facilitate State and Federal Policy</h5>
                        <p className="text">PJM works closely with state and federal policymakers to help inform important policy discussions.</p>
                        <p className="text">PJM has significant interaction in Washington, D.C., working to communicate PJM’s mission with FERC, U.S. Department of Energy, Congress and a host of other policymakers.</p>
                        <p className="text">PJM serves as a resource for the diverse states in the PJM footprint, providing information, data and analysis to help inform and implement the evolving state policy landscape. PJM was engaged with state and federal policy matters throughout 2021, providing testimony, information and analysis on state and federal policy endeavors.</p>
                    </div>
                </div>
                <div className="sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12 col-md-5">
                            <div className="profile-wrap">
                                <div className="profile">
									<img objectFit="contain" className="avatar" src={imgAsim} alt="" />
                                    <img className="rings" src={ringsbm} alt="" /> 
                                </div>
                            </div>
                       </div>
                       <div className="col-xs-12 col-md-7">
                            <blockquote>
                                <p className="text--blue">“PJM seeks to be an independent and trusted source of information for policymakers and utilizes expertise to advance policy in a reliable and cost-effective manner.”</p>
                            </blockquote>
                            <div className="text--author text--uppercase text--blue">Asim Haque, Vice President – State & Member Services</div>
                       </div>
                    </div>
                </div>                
            </main>
            <Footer 
                nextLink="/planning" 
                nextImage={nextImage}
                nextText="Next &gt;"
                nextButton="Read More" 
                nextTitle="Planning" 
                nextRings={nextRings}
                prevLink="/markets" 
                prevImage={prevImage}
                prevText="&lt; Previous"
                prevButton="Read More" 
                prevTitle="Markets" 
                prevRings={prevRings}
            />
        </Layout>
    )
}

export default ReliabilityPage
